import { PageChrome, ROUTES } from '@/components/gg/chrome'
import { CoinCase } from '@/pages/CoinCase'

/**
 * Achievements (/app/achievements; /app/coins redirects here): Brian's coin
 * album (after/coins.html v1.4). Opened from Settings and the desktop sidebar;
 * opening it clears the unviewed count.
 */
export function AchievementsPage() {
  return (
    <>
      <PageChrome title="Achievements" navKey="achievements" back={{ to: ROUTES.settings, label: 'Settings' }} />
      <CoinCase />
    </>
  )
}
